<div class="container-fluid">
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-book mr-2"></i>{{ menu.bookReportI18n }}
  </h1>

  <!-- Description -->
  <p class="lead mb-4">
    This report provides detailed information on books, including their ISBN, titles, authors, categories, and publishers. Use the filters below to narrow down the report based on publisher, category, writer, or year. Click "Search" to view the filtered data.
  </p>

  <!-- Filters and Search Button -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectPublisher($event.target.value)"
      >
        <option selected>Select Publisher</option>
        <option value="{{ c.id }}" *ngFor="let c of publishers$">
          {{ c.name }}
        </option>
      </select>

      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectCategory($event.target.value)"
      >
        <option selected>Select Category</option>
        <option value="{{ c.id }}" *ngFor="let c of categories$">
          {{ c.category_name }}
        </option>
      </select>

      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectWriter($event.target.value)"
      >
        <option selected>Select Writer</option>
        <option value="{{ c.id }}" *ngFor="let c of writers$">
          {{ c.name }}
        </option>
      </select>

      <select
        class="col-sm-2 custom-select"
        id="inputGroupSelect04"
        (change)="selectYear($event.target.value)"
      >
        <option selected>Select Year</option>
        <option value="{{ y.year }}" *ngFor="let y of years">
          {{ y.year}}
        </option>
      </select>

      <button
        (click)="search()"
        href="#"
        role="button"
        class="btn btn-info btn-icon-split"
      >
        <span class="icon text-white-50">
          <i class="fas fa-filter"></i>
        </span>
        <span class="text">Filter</span>
      </button>
    </div>
  </div>

  <!-- Data Table -->
  <div class="card shadow mb-4" *ngIf="searchButtonClicked">
    <div class="card-body">
      <div class="table-responsive">
        <div class="export-buttons">
          <button class="btn btn-outline-primary" (click)="exportToCSV()">Export to CSV</button>
          <button class="btn btn-outline-secondary" (click)="exportToPDF()">Export to PDF</button>
        </div>
        <table
          id="table"
          class="table table-bordered"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>{{ bookI18n?.isbnI18n }}</th>
              <th>{{ bookI18n?.titleI18n }}</th>
              <th>{{ bookI18n?.authorI18n }}</th>
              <th>{{ bookI18n?.categoryI18n }}</th>
              <th>{{ bookI18n?.publisherI18n }}</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>{{ bookI18n?.isbnI18n }}</th>
              <th>{{ bookI18n?.titleI18n }}</th>
              <th>{{ bookI18n?.authorI18n }}</th>
              <th>{{ bookI18n?.categoryI18n }}</th>
              <th>{{ bookI18n?.publisherI18n }}</th>
            </tr>
          </tfoot>
          <tbody>
            <tr *ngFor="let b of books$">
              <td>{{ b.isbn }}</td>
              <td>{{ b.title }}</td>
              <td>{{ b.writer?.name }}</td>
              <td>{{ b.category?.category_name }}</td>
              <td>{{ b.publisher?.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
